import moment from "moment";
import _lodash from "lodash";
import { iClientesAdministrados } from "../../interfaces/backendApi/clientesAdministrados";
interface IIdsExtraidos {
  idTarea: string | null;
  idCaso: string | null;
  linkDisplayName: string | null;
}
export const obtenerIds = (texto: string, patron1: string, patron2: string, patron3: string, patron4: string, patron5: string): IIdsExtraidos => {
  const obtenerId = (patron: string): string | null => {
    const regex = new RegExp(
      `${patron.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(\\d+)`
    );

    return texto.match(regex)?.[1] ?? null;
  };

  const obtenerTexto = (patron: string): string | null => {
    const regex = new RegExp(
      `${patron.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\s*([^\\s)]+)`
    );

    return texto.match(regex)?.[1] ?? null;
  };

  // Intentar con los patrones proporcionados
  let idTarea = obtenerId(patron1);
  let idCaso = obtenerId(patron2);
  let linkDisplayName = obtenerTexto(patron3);
  let hs = obtenerTexto(patron4);
  let min = obtenerTexto(patron5);

  // Fallback: regex flexible que soporta tanto "con el id" como "con id"
  if (!idTarea) {
    const regexTarea = /tarea con\s+(?:el\s+)?id\s+(\d+)/i;
    idTarea = texto.match(regexTarea)?.[1] ?? null;
  }

  if (!idCaso) {
    const regexCaso = /\(Caso\s+(\d+)\)/i;
    idCaso = texto.match(regexCaso)?.[1] ?? null;
  }

  if (!linkDisplayName) {
    const regexDisplayName = /\(displayName\s+([^)]+)\)/i;
    linkDisplayName = texto.match(regexDisplayName)?.[1]?.trim() ?? null;
  }
  if (!hs) {
    const regexhs = /\(hs\s+([^)]+)\)/i;
    hs = texto.match(regexhs)?.[1]?.trim() ?? null;
  }
  if (!min) {
    const regexmin = /\(min\s+([^)]+)\)/i;
    hs = texto.match(regexmin)?.[1]?.trim() ?? null;
  }
  return {
    idTarea,
    idCaso,
    linkDisplayName
  };
};


export const ordenarTareas = (
  a: { last_update_date: string },
  b: { last_update_date: string },
) => {
  const fechaA = parseFechaLast_update_date(a.last_update_date);
  const fechaB = parseFechaLast_update_date(b.last_update_date);
  return new Date(fechaB).getTime() - new Date(fechaA).getTime();
};

export const ordenarCasos = (a: any, b: any) => {
  // Comparación por last_update_date
  const fechaA = new Date(a.last_update_date).getTime();
  const fechaB = new Date(b.last_update_date).getTime();
  if (fechaA !== fechaB) {
    return fechaA - fechaB;
  }

  // Si las fechas son iguales, compara por caseId
  const caseIdA = parseInt(a.caseId);
  const caseIdB = parseInt(b.caseId);
  if (caseIdA !== caseIdB) {
    return caseIdA - caseIdB;
  }

  // Si caseId también es igual, compara por priority
  const prioridadA = a.priority;
  const prioridadB = b.priority;
  if (prioridadA < prioridadB) {
    return -1;
  }
  if (prioridadA > prioridadB) {
    return 1;
  }

  // Si todo es igual, no hay cambio en el orden
  return 0;
};

export const parseFechaHoraInicio = (fechaString: string) => {
  return moment(fechaString, "DD/MM/YYYY HH:mm:ss").toDate();
};
export const parseFechaStart = (fechaString: string) => {
  return moment(fechaString, "YYYY/DD/MM HH:mm:ss").toDate();
};

export const parseFechaLast_update_date = (fechaString: string) => {
  //return moment(fechaString, "DD/MM/YYYY HH:mm:ss").toDate();
  return moment(fechaString, "yyyy/MM/DD  HH:mm:ss").toDate();
};

export const compararPorFecha = (
  a: { FechaHoraInicio: string },
  b: { FechaHoraInicio: string },
) => {
  const fechaA = parseFechaHoraInicio(a.FechaHoraInicio);
  const fechaB = parseFechaHoraInicio(b.FechaHoraInicio);

  return new Date(fechaA).getTime() - new Date(fechaB).getTime();
};

export const compararPorCaso = (a: { Caso: number }, b: { Caso: number }) => {
  return a.Caso - b.Caso;
};
export const formatearMensajeBackend = (mensaje: string) => {
  const regex = /<[^>]*>/g;
  return mensaje.replace(regex, " ");
};

export const ordenarCasosBackend = (
  a: { FechaHoraInicio: string },
  b: { FechaHoraInicio: string },
) => {
  const fechaA = parseFechaHoraInicio(a.FechaHoraInicio);
  const fechaB = parseFechaHoraInicio(b.FechaHoraInicio);
  return new Date(fechaB).getTime() - new Date(fechaA).getTime();
};

export const compararFechasAmilisegundo = (fechaA: string, fechaB: string) => {
  const fechaAMilisegundos = Date.parse(fechaA);
  const fechaBMilisegundos = Date.parse(fechaB);
  return fechaAMilisegundos - fechaBMilisegundos; // Ordenar de más reciente a más antigua
};

export const ordenarCasosBackendTrue = (
  a: { FechaHoraInicio: string },
  b: { FechaHoraInicio: string },
) => {
  const fechaA = parseFechaHoraInicio(a.FechaHoraInicio);
  const fechaB = parseFechaHoraInicio(b.FechaHoraInicio);
  return new Date(fechaB).getTime() - new Date(fechaA).getTime();
};
export const ordenarCasosUsuarioBackend = (
  a: { start: string },
  b: { start: string },
) => {
  const fechaA = parseFechaHoraInicio(a.start);
  const fechaB = parseFechaHoraInicio(b.start);
  return new Date(fechaB).getTime() - new Date(fechaA).getTime();
};
export const ordenarCasosArchivadosBackend = (
  a: { FechaHoraFin: string },
  b: { FechaHoraFin: string },
) => {
  const fechaA = parseFechaHoraInicio(a.FechaHoraFin);
  const fechaB = parseFechaHoraInicio(b.FechaHoraFin);
  return new Date(fechaA).getTime() - new Date(fechaB).getTime();
};

export const ordenarTareasLodashBackend = (arrayAOrdenar: any[]) => {
  const arrayOrdenado = _lodash.orderBy(
    arrayAOrdenar,
    "last_update_date",
    "asc",
  );
  return arrayOrdenado;
};

export const ordenarCasosLodashBackend = (arrayAOrdenar: any[]) => {
  const arrayOrdenado = _lodash.orderBy(
    arrayAOrdenar,
    "FechaHoraInicio",
    "asc",
  );
  return arrayOrdenado;
};

export const HelperUniqueItemArray = (
  ItemsArray: any[] | iClientesAdministrados[],
) => {
  const uniqueItemArray = _lodash.uniqBy(ItemsArray, JSON.stringify);

  return uniqueItemArray;
};

export const ordenarContratoVigencia = (
  a: { Vigente: number },
  b: { Vigente: number },
): number => {
  if (a.Vigente && !b.Vigente) return -1; // a va primero
  if (!a.Vigente && b.Vigente) return 1; // b va primero
  return 0; // no cambia la posición
};
// Mapeo de valores de prioridad
const priorityMapping: Record<string, string> = {
  highest: "Critica",
  high: "Mayor",
  critical: "Critica",
  above_normal: "Mayor",
  normal: "Mayor",
  under_normal: "Menor",
  lowest: "Menor",
};

export const procesarPrioridades = (data: any[]) => {
  return data.map((item) => {
    let nuevaPrioridad = priorityMapping[item.priority] || item.priority;
    return { ...item, priority: nuevaPrioridad };
  });
};

export const procesarTomadasPrioridades = (data: any[]) => {
  return data.map((item) => {
    let nuevaPrioridad = priorityMapping[item.priority] || item.priority;
    return { ...item, priority: nuevaPrioridad };
  });
};

export const procesarPrioridad = (data: any[]) => {
  return data.map((item) => {
    const nuevaPrioridad = priorityMapping[item.Prioridad] || item.Prioridad;
    return { ...item, Prioridad: nuevaPrioridad };
  });
};

export const procesarPropiedadMapeo = (data: any[], propiedad: string) => {
  return data.map((item) => {
    const valorOriginal = _lodash.get(item, propiedad);
    const nuevaPropiedad = priorityMapping[valorOriginal] || valorOriginal;
    return { ...item, [propiedad]: nuevaPropiedad };
  });
};
export const procesarDosPropiedadMapeos = (
  data: any[],
  origen: string,
  destino: string,
) => {
  return data.map((item) => {
    const valorOriginal = _lodash.get(item, origen);
    const nuevaPropiedad = priorityMapping[valorOriginal] || valorOriginal;
    return { ...item, [destino]: nuevaPropiedad };
  });
};

export const procesarDosPropiedadMapeo = (
  data: any[],
  origen: string,
  destino: string,
) => {
  return data.map((item) => {
    const valorOriginal = _lodash.get(item, origen);
    const nuevaPropiedad = priorityMapping[valorOriginal] || valorOriginal;
    return { ...item, [destino]: nuevaPropiedad };
  });
};
interface DiferenciaTiempoParams {
  fechaInicio: string;
  fechaActual: string;
  formato?: string;
  minAntes?: number;
}

export const calcularDiferenciaTiempo = ({
  fechaInicio,
  fechaActual,
  formato = "DD/MM/YYYY HH:mm:ss",
  minAntes = 15,
}: DiferenciaTiempoParams): string => {
  const inicio = moment(fechaInicio, formato);
  const actual = moment(fechaActual, formato);

  // Cálculo de diferencias
  const dias = inicio.diff(actual, "days");
  actual.add(dias, "days");

  const horas = inicio.diff(actual, "hours");
  actual.add(horas, "hours");

  let minutos = inicio.diff(actual, "minutes");
  minutos = minutos - minAntes;
  if (minutos < 0) {
    minutos = 0;
  }

  // Resultado formateado
  return `Podras tomar la tarea en : ${dias} días, ${horas} horas, ${minutos}  minutos`;
};
export const diferenciaTiempo = ({
  fechaInicio,
  fechaActual,
  formato = "DD/MM/YYYY HH:mm:ss",
}: DiferenciaTiempoParams): string => {
  const inicio = moment(fechaInicio, formato);
  const actual = moment(fechaActual, formato);

  // Cálculo de diferencias
  const dias = inicio.diff(actual, "days");
  actual.add(dias, "days");

  const horas = inicio.diff(actual, "hours");
  actual.add(horas, "hours");

  const minutos = inicio.diff(actual, "minutes");
  return `${minutos}`;
};

interface DiferenciaTotalMinutosParams {
  fechaInicio: string;
  fechaActual: string;
  formato?: string;
}
export const calcularDiferenciaTotalMinutos = ({
  fechaInicio,
  fechaActual,
  formato = "DD/MM/YYYY HH:mm:ss",
}: DiferenciaTotalMinutosParams): number => {
  const inicio = moment(fechaInicio, formato);
  const actual = moment(fechaActual, formato);

  // Calcular la diferencia total en minutos
  const diferenciaTotalMinutos = inicio.diff(actual, "minutes");
  //const diferenciaTotalMinutos = actual.diff(inicio, "minutes");
  return diferenciaTotalMinutos;
};
export const filterDescriptions = (item: { Descripcion: string }) => {
  const excludedDescriptions = ["Estimación"];
  return (
    !excludedDescriptions.includes(item.Descripcion) &&
    !item.Descripcion.startsWith("Escalar")
  );
};

export const obtenerTimeZoneNum = () => {
  // `getTimezoneOffset` devuelve el desfase en minutos (negativo para zonas al este de UTC)
  const desfaseEnMinutos = new Date().getTimezoneOffset();
  // Convertir a horas y cambiar el signo para que sea estándar con UTC
  return -desfaseEnMinutos / 60;
};

export const shouldRenderTicket = (ticketRedmine: any): boolean => {
  if (
    ticketRedmine !== "0" &&
    ticketRedmine !== "" &&
    Number(ticketRedmine) > 0
  ) {
    return true;
  }
  return false;
};

// Puedes poner esto en un archivo utilitario, por ejemplo, utils/mimeUtils.ts

// Mapeo de MIME types conocidos a sus extensiones (incluyendo el punto)
// Nota: Algunos MIME types pueden tener múltiples extensiones comunes (ej: jpeg/jpg)
const mimeTypeToExtensionMap: Record<string, string[]> = {
  "text/css": [".css"],
  "text/plain": [".txt", ".log"],
  "text/csv": [".csv"],
  "text/html": [".html", ".htm"],
  "application/json": [".json"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/pdf": [".pdf"],
  "image/jpeg": [".jpeg", ".jpg"], // Ambas son comunes
  "image/png": [".png"],
  "application/x-drawio": [".drawio"], // Asumiendo esta extensión
  "image/gif": [".gif"],
  "image/jpg": [".jpg"], // Incluido explícitamente aunque cubierto por image/jpeg
  "application/vnd.ms-project": [".mpp"],
  "application/vnd.oasis.opendocument.spreadsheet": [".ods"],
  "application/vnd.oasis.opendocument.text": [".odt"],
  "application/x-oracle-ora": [".ora"], // Asumiendo esta extensión
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    ".pptx",
  ],
  "application/rtf": [".rtf"],
  "application/vnd.ms-excel.sheet.macroenabled.12": [".xlsm"],
  "application/yaml": [".yaml", ".yml"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  // Añade más mapeos si los necesitas
};

/**
 * Genera una cadena de accept para input[type=file] a partir de un array de MIME types.
 * @param allowedMimeTypes Array de MIME types permitidos.
 * @returns Una cadena formateada como ".ext1,.ext2,.ext3"
 */
export function generateAcceptString(allowedMimeTypes: string[]): string {
  const extensions = new Set<string>(); // Usamos un Set para evitar duplicados

  allowedMimeTypes.forEach((mimeType) => {
    const exts = mimeTypeToExtensionMap[mimeType.toLowerCase()]; // Busca en el mapa (insensible a mayúsculas/minúsculas)
    if (exts) {
      exts.forEach((ext) => extensions.add(ext)); // Agrega todas las extensiones encontradas al Set
    } else {
      console.warn(
        `[generateAcceptString] No se encontró mapeo para el MIME type: ${mimeType}`,
      );
      // Opcional: podrías intentar una heurística simple como último recurso,
      // pero es propenso a errores. Por ejemplo:
      // const potentialExt = "." + mimeType.split('/')[1]?.split('+')[0]?.split('.').pop();
      // if (potentialExt && potentialExt.length > 1 && potentialExt.length < 6) {
      //   extensions.add(potentialExt);
      // }
    }
  });

  return Array.from(extensions).join(","); // Convierte el Set a Array y une con comas
}


export const formatDescripcion = (descripcion?: string): string => {
  if (!descripcion) return "";

  try {
    const data = JSON.parse(descripcion);
    return Object.entries(data)
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n");
  } catch {
    return descripcion;
  }
};

/**
 * Parsea un string JSON de descripción y retorna el valor asociado a la key indicada.
 * @param descripcion - String JSON con los datos a filtrar.
 * @param key - Clave cuyo valor se desea obtener.
 * @returns El valor como string, o "" si la clave no existe o el JSON es inválido.
 */
export const getValueFromDescripcion = (
  descripcion: string,
  key: string,
): string => {
  if (!descripcion || !key) return "";

  try {
    const data = JSON.parse(descripcion);
    const value = data[key];
    return value !== undefined && value !== null ? `${value}` : "";
  } catch {
    return "";
  }
};
